(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdjb-brand-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(strip) {
    if (strip.dataset.spin) return;
    strip.dataset.spin = '1';
    var vp = strip.querySelector('.sdjb-brandstrip__viewport');
    var track = strip.querySelector('.sdjb-brandstrip__track');
    if (!vp || !track) return;
    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;
    var oneSet = 0;

    function build() {
      Array.prototype.slice.call(track.querySelectorAll('[data-clone]')).forEach(function (n) { n.remove(); });
      function appendSet() {
        originals.forEach(function (li) {
          var c = li.cloneNode(true);
          c.setAttribute('data-clone', '');
          c.setAttribute('aria-hidden', 'true');
          Array.prototype.slice.call(c.querySelectorAll('a')).forEach(function (a) { a.tabIndex = -1; });
          track.appendChild(c);
        });
      }
      appendSet();
      oneSet = track.children[originals.length].offsetLeft - track.children[0].offsetLeft;
      var target = Math.max(vp.clientWidth * 3, oneSet * 2);
      var guard = 0;
      while (track.scrollWidth < target && guard < 24) { appendSet(); guard++; }
    }
    build();

    var speed = 0.5, paused = false, dragging = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function tick() {
      if (!paused && !dragging && oneSet > 0) {
        vp.scrollLeft += speed;
        if (vp.scrollLeft >= oneSet) vp.scrollLeft -= oneSet;
      }
      requestAnimationFrame(tick);
    }
    if (!reduce) requestAnimationFrame(tick);

    vp.addEventListener('mouseenter', function () { paused = true; });
    vp.addEventListener('mouseleave', function () { if (!dragging) paused = false; });

    var startX = 0, startScroll = 0, moved = false;
    vp.addEventListener('pointerdown', function (e) {
      paused = true;
      if (e.pointerType === 'mouse') {
        dragging = true; moved = false; startX = e.clientX; startScroll = vp.scrollLeft;
        try { vp.setPointerCapture(e.pointerId); } catch (x) {}
        vp.classList.add('is-dragging');
      }
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging || oneSet <= 0) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      var sl = (startScroll - dx) % oneSet;
      if (sl < 0) sl += oneSet;
      vp.scrollLeft = sl;
    });
    function endDrag() {
      if (dragging) { dragging = false; vp.classList.remove('is-dragging'); }
      paused = false;
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 200); });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('.sdjb-brandstrip')).forEach(function (s) {
      var imgs = Array.prototype.slice.call(s.querySelectorAll('img'));
      var pending = imgs.filter(function (i) { return !(i.complete && i.naturalWidth); });
      if (!pending.length) { setup(s); return; }
      var done = 0, started = false;
      function go() { if (!started) { started = true; setup(s); } }
      pending.forEach(function (i) {
        function fin() { done++; if (done >= pending.length) go(); }
        i.addEventListener('load', fin); i.addEventListener('error', fin);
      });
      setTimeout(go, 1500);
    });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
